import { jsonToQueryString } from "../shared/utils";
import ApiBase from "./base";

export const _AUDIT_URL = "audit";

export async function getAuditList(params) {
    const response = await ApiBase.get(`${_AUDIT_URL}?${jsonToQueryString(params)}`);

    return response;
}

